import React from 'react';
import { Loader2, AlertCircle } from 'lucide-react';

interface Props {
  state: 'loading' | 'error';
  errorMessage?: string;
  onDismiss?: () => void;
}

const JobLoadingModal: React.FC<Props> = ({ state, errorMessage, onDismiss }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-sm w-full p-6 flex flex-col items-center gap-4">
        {state === 'loading' ? (
          <>
            <Loader2 className="w-10 h-10 text-jobesta-blue animate-spin" />
            <p className="text-jobesta-gray-80 font-medium text-center">Loading job details...</p>
          </>
        ) : (
          <>
            <AlertCircle className="w-10 h-10 text-red-500" />
            <p className="text-jobesta-gray-80 font-medium text-center">
              {errorMessage || 'Something went wrong.'}
            </p>
            <button
              onClick={onDismiss}
              className="mt-2 px-5 py-2 rounded-lg bg-jobesta-blue text-white text-sm font-medium hover:bg-opacity-90 transition-colors"
            >
              Dismiss
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default JobLoadingModal;
